var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.color,"text-color":"#ffffff","label":""}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(" fas fa-users ")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }